module.exports = __webpack_public_path__ + "media/images/bg/mosaic/monika-48293e2406703a4bd98e06032d58d8ed.jpg";